import React from 'react';
import { LoadingSpinner } from 'components/spinner/loading-spinner.component';
import { FullScreenContainer } from 'components/full-screen-container.component';

export const FullPageLoadingSpinner = () => (
  <FullScreenContainer backgroundColor="surface.background.primary">
    <LoadingSpinner />
  </FullScreenContainer>
);
